import { useKeycloak } from '@project/auth/keycloakInstance';
import { useEffect, useRef, useState } from 'react';

export const useSessionTimeout = (warningSeconds = 60) => {
  const { keycloak, logout } = useKeycloak();
  const [showWarning, setShowWarning] = useState(false);
  const [timeLeft, setTimeLeft] = useState(warningSeconds);

  const logoutRef = useRef(logout);
  useEffect(() => {
    logoutRef.current = logout;
  }, [logout]);

  const keycloakRef = useRef(keycloak);
  useEffect(() => {
    keycloakRef.current = keycloak;
  }, [keycloak]);

  useEffect(() => {
    const checkSession = () => {
      try {
        const expiry = keycloakRef.current.refreshTokenParsed?.exp;

        if (!expiry) {
          console.log('Token not parsed yet, skipping session check');
          return;
        }

        const now = Math.floor(Date.now() / 1000);
        const remaining = expiry - now;

        if (remaining <= warningSeconds && remaining > 0) {
          setShowWarning(true);
          setTimeLeft(remaining);
        } else if (remaining <= 0) {
          setShowWarning(false);
          logoutRef.current();
        } else {
          setShowWarning(false);
        }
      } catch (error) {
        console.error('Error checking session:', error);
      }
    };

    const timer = setInterval(checkSession, 1000);
    return () => clearInterval(timer);
  }, [warningSeconds]);

  return { showWarning, timeLeft };
};
